export const getFeatures = (features) => {
  const validFeatures = features?.calls && features?.orders;
  if (!validFeatures) return { hasLive: false, hasMenu: true };
  const { calls, orders } = features;
  return { hasLive: calls.active || orders.active, hasMenu: true };
};
